import React, {useEffect, useRef, useState} from "react";
import {useStyles} from "../styles/OddListeningStepStyle";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import {Box, Button, Popover, Typography} from "@material-ui/core";
import clsx from "clsx";
import {ReactComponent as CheckPointIcon} from "../../../../../common/images/CheckPointIcon.svg";
import {ReactComponent as TooltipTipIcon} from "../../../../../common/images/TooltipTipIcon.svg";
import {ReactComponent as TooltipClose} from "../../../../../common/images/TooltipClose.svg";
import CutTextIcon from "../../../../../common/images/CutTextIcon.svg";

function AfterDividedState(props) {
    const { oddStepOneStore, contentStore, dialogStore } = props;

    const anchorElRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(0);

    useEffect(() => {
        setAnchorEl(anchorElRef.current);
        oddStepOneStore.setPopoverState(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleClosePopover = () => {
        setAnchorEl(null);
        oddStepOneStore.setPopoverState(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const classes = useStyles();
    const content = oddStepOneStore.getSelectedTempContent();
    const text = content.text;
    const pieceList = oddStepOneStore.dividedNumber === 1 ? content.topPieceList : content.bottomPieceList;

    const handleClick = (index, isMarker) => {
        if (!isMarker) {
            if (pieceList.length === 0) {
                oddStepOneStore.addPiece(pieceList, {textStartIndex: 0, textEndIndex: index});
                oddStepOneStore.addPiece(pieceList, {textStartIndex: index + 1, textEndIndex: text.length - 1});
            } else {
                const targetPiece = pieceList.find(piece => piece.textStartIndex <= index && piece.textEndIndex >= index);
                const targetPieceIndex = pieceList.findIndex(piece => piece.textStartIndex <= index && piece.textEndIndex >= index);

                if (targetPiece) {
                    oddStepOneStore.addPiece(pieceList, {textStartIndex: targetPiece.textStartIndex, textEndIndex: index});
                    oddStepOneStore.addPiece(pieceList, {textStartIndex: index + 1, textEndIndex: targetPiece.textEndIndex});
                    oddStepOneStore.removePiece(pieceList, targetPieceIndex);
                    oddStepOneStore.sortPieceList(pieceList);
                }
            }
        }

        if (isMarker) {
            if (pieceList.length === 2) {
                oddStepOneStore.removePiece(pieceList, 0);
                oddStepOneStore.removePiece(pieceList, 0);
            } else {
                const targetPiece = pieceList.find(piece => piece.textEndIndex === index);
                const targetPieceIndex = pieceList.findIndex(piece => piece.textEndIndex === index);

                const afterPiece = pieceList.filter(piece => piece.textStartIndex > targetPiece.textEndIndex).reduce((min, current) => {
                    return current.textStartIndex < min.textStartIndex ? current : min;
                }, pieceList.filter(piece => piece.textStartIndex > targetPiece.textEndIndex)[0]);

                oddStepOneStore.setPieceTextIndex(afterPiece, targetPiece.textStartIndex, afterPiece.textEndIndex);
                oddStepOneStore.removePiece(pieceList, targetPieceIndex);
            }
        }
    }

    const cautionToSplit = () => {
        dialogStore.openErrorDialog({
            titleText: "본문 나누기 오류",
            text:"본문1, 본문2의 나누어진 문장의 갯수가 일치할 수 없습니다.",
        })
    }

    const onClickSuccessButton = () => {
        if (content.topPieceList.length === content.bottomPieceList.length) {
            cautionToSplit();
        } else {
            oddStepOneStore.savePieceListTextIndex();
            oddStepOneStore.setIsProcessing(false);
            contentStore.setReadyToSaveStep(oddStepOneStore.isChangeContent());
        }
    }

    return (
        <>
            <Box className={classes.textCutBoxContainer}>
                <Box ref={anchorElRef} className={classes.textCutBox} variant="contained" color="primary">
                    {text.split('').map((char, index) => {
                        const isMaker = pieceList.some(piece => piece.textEndIndex === index && (index !== text.length - 1));
                        const isSpace = char === ' ';

                        return <span
                            style={{paddingRight: isSpace ? '9px' : null, cursor: isMaker ? 'pointer' : 'url(' + CutTextIcon + ') 20 10, auto'}}
                            className={classes.textSpace}
                            onClick={() => handleClick(index, isMaker)}
                            key={index}>
                                {isMaker ? <>{char}<CheckPointIcon/></> : char}
                        </span>
                    })}
                </Box>
                <Popover
                    id={id}
                    open={oddStepOneStore.popoverState === null ? false : oddStepOneStore.popoverState}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    className={classes.popoverTooltip}
                >
                    <Box className={classes.tooltipTop}>
                        <TooltipTipIcon/>
                    </Box>
                    <Box display={'flex'} justifyContent={'flex-end'} className={classes.tooltipBtn}>
                        <Button disableRipple onClick={handleClosePopover}>
                            <TooltipClose/>
                        </Button>
                    </Box>
                    <Typography className={classes.typography}>1. 문자 사이 공간을 클릭하면 <CheckPointIcon/>표시가 생성되고<br/>해당 표시를
                        기준으로 본문이 나누어 집니다.</Typography>
                    <Typography className={classes.typography}>2. <CheckPointIcon/>표시를 클릭하면 나누기가 취소됩니다.</Typography>
                </Popover>
            </Box>
            <Box display={"flex"} justifyContent={"flex-end"}>
                <Box className={clsx(classes.uncomplete, classes.complete)}>
                    <Button onClick={onClickSuccessButton} disableRipple>
                        <Typography>완료</Typography>
                    </Button>
                </Box>
            </Box>
        </>
    )
}

export default withRouter(inject('contentStore','oddStepOneStore','dialogStore')(observer(AfterDividedState)));
